module.exports = __webpack_public_path__ + "static/media/fsc-logo.fd5c5e0c.svg";